$(document).ready(function() {

    $("li:first-child").addClass("first");
    $("li:last-child").addClass("last");

    $('[href="#"]').attr("href", "javascript:;");

    $(".menu-Bar").click(function() {
        // $(this).toggleClass("open");
        // $(".menuWrap").toggleClass("open");

       $(".new-megamenu-wrapper").addClass("new-mm-active");
    $("body").addClass("ovr-hiddn");
    });
  
 
  
    /* Tabbing Function */
    $("[data-targetit]").on("click", function(e) {
        $(this).addClass("active");
        $(this)
            .siblings()
            .removeClass("active");
        var target = $(this).data("targetit");
        $("." + target)
            .siblings('[class^="box-"]')
            .hide();
        $("." + target).show()
        $(".tabViewList").slick("setPosition", 0);
    });

  // Accordian
    $(".faq-accordian h4").click(function() {
        if (
            $(this)
            .parent("li")
            .hasClass("active")
        ) {
            $(this)
                .parent("li")
                .removeClass("active");
            $(this)
                .next()
                .slideUp();
        } else {
            $(".faq-accordian li").removeClass("active");
            $(this)
                .parent("li")
                .addClass("active");
            console.log("Doesnt have active");
            $(".faq-accordian li div").slideUp();
            $(this)
                .parent("li")
                .find("div")
                .slideDown();
        }
    });


     // Accordian new
    $(".accordian-support h4").click(function() {
        $(".accordian-support>li").removeClass("active");
        $(this)
            .parent("li")
            .addClass("active");
        $(".accordian-support>li>div").slideUp();
        $(this)
            .parent("li")
            .find("div")
            .slideDown();
    });  

    ///faq all accordian
    $(".faqs-main-content-items h4").click(function() {
        $(".faqs-main-content-items>li").removeClass("active");
        $(this)
            .parent("li")
            .addClass("active");
        $(".faqs-main-content-items>li div").slideUp();
        $(this)
            .parent("li")
            .find("div")
            .slideDown();
    });  


  
    $(".nova-product-specs-accordion>li .nova-product-specs-accordion-heading").click(function() {

      
      if (($(this).hasClass('accordion-shipping') || $(this).hasClass('accordion-why-nova')) &&
        $('.nova-product-specs-accordion').get(0).childElementCount > 3
      ) {
        console.log("Yepp");
        $('.nova-product-specs-accordion > li:nth-child(1), .nova-product-specs-accordion > li:nth-child(2)').fadeOut();
      } else {
        $('.nova-product-specs-accordion > li:nth-child(1), .nova-product-specs-accordion > li:nth-child(2)').fadeIn();
      }


      if($(this).parent().hasClass('active'))
      {
        $(".nova-product-specs-accordion>li").removeClass("active");
        $(".nova-product-specs-accordion>li .nova-product-specs-accordion-body").slideUp();
        $('.nova-product-specs-accordion>li:nth-child(1),.nova-product-specs-accordion>li:nth-child(2)').fadeIn();
      }
      else{
      
        $(".nova-product-specs-accordion>li").removeClass("active");
        $(this)
            .parent("li")
            .addClass("active");
        $(".nova-product-specs-accordion>li .nova-product-specs-accordion-body").slideUp();
        $(this)
            .parent("li")
            .find(".nova-product-specs-accordion-body")
            .slideDown();
      }
    
    });  

    $(".perk-banners-slider").slick({
        dots: true,
      arrows:false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
      autoplay:true,
      swipe:true,
      touchMove:false,
      fade:true,
      prevArrow: "<span class='slider-btn slider-prev'><i class='fa fa-arrow-left'></i></span>",
      nextArrow: "<span class='slider-btn slider-next'><i class='fa fa-arrow-right'></i></span>"
    });

  
  //  $(".nova-megamenu-slider").slick({
  //       dots: false,
  //     arrows:false,
  //       infinite: false,
  //       speed: 700,
  //       slidesToShow: 1,
  //    draggable:false,
  //    swipe:false,
  //    swipeToSlide:false,
  //    touchMove:false,
  //    waitForAnimate:false,
  //   });


  // $('.nova-megamenu-collections>li').hover(function() {
  //       var sliderIndex = $(this).data('slider-index');
  //       console.log(sliderIndex);

  //     $('.nova-megamenu-collections>li').removeClass("active");
  //   $(this).addClass("active");
  //     $('.nova-megamenu-slider').slick('slickGoTo', sliderIndex);
  //   });


  

  
   $(".product-slider").slick({
        dots: false,
      arrows:true,
        infinite: false,
        speed: 1000,
        slidesToShow: 3,
      prevArrow: "<span class='product-slider-btn product-slider-prev'><i class='fal fa-long-arrow-left'></i></span>",
      nextArrow: "<span class='product-slider-btn product-slider-next'><i class='fal fa-long-arrow-right'></i></span>",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
     ]
    });
  
  
   $(".new-launches-slider").slick({
        dots: true,
      arrows:true,
        infinite: false,
        speed: 1000,
        autoplay:true,
     fade:true,
        slidesToShow: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            adaptiveHeight:true,
            
          }
        }
     ],
        prevArrow: "<span class='next-launch-slider-btn next-launch-slider-prev'><i class='fal fa-long-arrow-left'></i></span>",
      nextArrow: "<span class='next-launch-slider-btn next-launch-slider-next'><i class='fal fa-long-arrow-right'></i></span>",
      // prevArrow: "<span class='product-slider-btn product-slider-prev'><i class='fal fa-long-arrow-left'></i></span>",
      // nextArrow: "<span class='product-slider-btn product-slider-next'><i class='fal fa-long-arrow-right'></i></span>"
    });


    $(".collection-slider").slick({
        dots: true,
      arrows:false,
        infinite: true,
        speed: 1000,
      autoplay:true,
      
       fade:false,
        slidesToShow: 1,
      // prevArrow: "<span class='product-slider-btn product-slider-prev'><i class='fal fa-long-arrow-left'></i></span>",
      // nextArrow: "<span class='product-slider-btn product-slider-next'><i class='fal fa-long-arrow-right'></i></span>"
    });
    $(".lush-tv-promos-slider").slick({
        dots: true,
      arrows:false,
        infinite: true,
        speed: 1000,
      autoplay:true,
      autoplaySpeed:15000,
       fade:true,
        slidesToShow: 1,
      // prevArrow: "<span class='product-slider-btn product-slider-prev'><i class='fal fa-long-arrow-left'></i></span>",
      // nextArrow: "<span class='product-slider-btn product-slider-next'><i class='fal fa-long-arrow-right'></i></span>"
    });



   $(".featured-brands-slider").slick({
        dots: true,
      arrows:false,
        infinite: true,
        speed: 1000,
        slidesToShow:10,
     vertical:true,
      autoplay:false,
      swipe:false,
      touchMove:false,
     slidesToScroll:10,
      fade:false,
      prevArrow: "<span class='slider-btn slider-prev'><i class='fa fa-arrow-left'></i></span>",
      nextArrow: "<span class='slider-btn slider-next'><i class='fa fa-arrow-right'></i></span>"
    });

   $(".discover-more-slider").slick({
        dots: false,
      arrows:true,
        infinite: true,
        speed: 1000,
        slidesToShow:3,
    
      autoplay:true,
    autoplaySpeed:7500,
     slidesToScroll:1,
      fade:false,
      prevArrow: "<span class='slider-btn slider-prev'><i class='fa fa-arrow-left'></i></span>",
      nextArrow: "<span class='slider-btn slider-next'><i class='fa fa-arrow-right'></i></span>",
       responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        }
     ]
    });

  
   $(".featured-brands-slider-horizontal").slick({
        dots: true,
      arrows:false,
        infinite: true,
        speed: 1000,
        slidesToShow:10,
     // vertical:true,
      autoplay:false,
      swipe:false,
      touchMove:false,
     slidesToScroll:10,
     rows:3,
      fade:false,
      prevArrow: "<span class='slider-btn slider-prev'><i class='fa fa-arrow-left'></i></span>",
      nextArrow: "<span class='slider-btn slider-next'><i class='fa fa-arrow-right'></i></span>"
    });


  var $slider = $('.socials-slider');
  var $progressBar = $('.slick-progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
   $slider.slick({
        dots: false,
      arrows:true,
        infinite: true,
        speed: 700,
     fade:false,
     slidesToScroll:1,
        slidesToShow: 3.5,
      prevArrow: "<span class='social-slider-btn social-slider-prev'><i class='fal fa-angle-left'></i></span>",
      nextArrow: "<span class='social-slider-btn social-slider-next'><i class='fal fa-angle-right'></i></span>",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        }
     ]
    });
  


  
  
 


  //     Slider For
    $('.multi-slider-parent').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        fade: true,
        autoplay:true,
        asNavFor: '.multi-slider-child',
       prevArrow: "<span class='multi-slider-btn multi-slider-prev'><i class='fal fa-angle-left'></i></span>",
      nextArrow: "<span class='multi-slider-btn multi-slider-next'><i class='fal fa-angle-right'></i></span>",
    });
    $('.multi-slider-child').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.multi-slider-parent',
        dots: true,
      arrows:false,
      fade:true,
        focusOnSelect: true
    });
  

    //     Slider For
    // $('.slider-for').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     dots: false,
    //     arrows: false,
    //     fade: true,
    //     asNavFor: '.slider-nav'
    // });
    // $('.slider-nav').slick({
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     asNavFor: '.slider-for',
    //     dots: false,
    //     focusOnSelect: true
    // });

    /* Top Scroll */
    $('body').on('click', '#shop-scroll', function() {
        goToScroll('home-shop-sec');
    });

      $('body').on('click', '#shop-scroll2', function() {
        goToScroll('bg-pods-home-shop');
    });
  
 

 


  
  
  
});



  $(".lushvapes-product-specs-accordion>li .lushvapes-product-specs-accordion-heading").click(function() {

      
      // if (($(this).hasClass('accordion-shipping') || $(this).hasClass('accordion-why-lushvapes')) &&
      //   $('.lushvapes-product-specs-accordion').get(0).childElementCount > 3
      // ) {
      //   console.log("Yepp");
      //   $('.lushvapes-product-specs-accordion > li:nth-child(1), .lushvapes-product-specs-accordion > li:nth-child(2)').fadeOut();
      // } else {
      //   $('.lushvapes-product-specs-accordion > li:nth-child(1), .lushvapes-product-specs-accordion > li:nth-child(2)').fadeIn();
      // }


      if($(this).parent().hasClass('active'))
      {
        $(".lushvapes-product-specs-accordion>li").removeClass("active");
        $(".lushvapes-product-specs-accordion>li .lushvapes-product-specs-accordion-body").slideUp();
        $('.lushvapes-product-specs-accordion>li:nth-child(1),.lushvapes-product-specs-accordion>li:nth-child(2)').fadeIn();
      }
      else{
      
        $(".lushvapes-product-specs-accordion>li").removeClass("active");
        $(this)
            .parent("li")
            .addClass("active");
        $(".lushvapes-product-specs-accordion>li .lushvapes-product-specs-accordion-body").slideUp();
        $(this)
            .parent("li")
            .find(".lushvapes-product-specs-accordion-body")
            .slideDown();
      }
    
    });  





  if ($(window).width() > 767) {



  }







$(window).on("load", function() {
    
  
 



//embed widget additions


  
  
});





  

  
  

  if ($(window).width() < 767) {
    
 
}




  
  function goToScroll(e) {
  $("html, body").animate(
    {
      scrollTop: $("." + e).offset().top - 135,
    },
    1000
  );
}
  




